import { apiURL, responseFormat } from '@/service/base'
import { MembersClient } from '@circusmonkey/spock-protobuf/ts/frontend/member_grpc_web_pb.js'

const client = new MembersClient(apiURL, null, null)

/**
 * 取跑馬燈清單
 * @param func
 * @returns {Promise<unknown>}
 */
async function getMarqueesList(params = {}, func = null) {
	const req = new proto.base.Empty()

	const option = { 'grpc-session': localStorage.getItem('grpc-session') }
	const url = String(client.getMarquees.toString().split('\n')[2]).replace(/\s+/g, '')
	const track = { req: req.toObject(), url }
	return new Promise((resolve, reject) => {
		client.getMarquees(req, option, (err, response) => {
			if (typeof func === 'function') resolve(func(err, response, track))
			else resolve(responseFormat(err, response, track, true, 'marquees'))
		})
	}).then(resp => resp)
}

export {
	getMarqueesList
}
